import { css } from '@emotion/core';
import { panels } from 'styles';

export const actions = css`
  ${panels.base}
  padding: 20px 15px 10px;
  margin-top: 15px;
`;
